import type { DashboardElement } from '../types/dashboard'

export type DashboardConfig = {
  isConfigurable: boolean
  elements: DashboardElement[]
}

export const saveConfiguration = (config: Partial<DashboardConfig>, location: string) => {
  const savedConfig = loadConfiguration() || {}
  const newConfig = { ...savedConfig, ...config }
  if (process.env.NODE_ENV === 'development') console.log('Saving configuration from', location, newConfig)
  localStorage.setItem('dashboardConfig', JSON.stringify(newConfig))
}

export const loadConfiguration = (): DashboardConfig | null => {
  try {
    const saved = localStorage.getItem('dashboardConfig')
    if (!saved) return null
    return JSON.parse(saved)
  } catch (error) {
    console.error('Failed to load dashboard configuration:', error)
    return null
  }
}
